import type { createFileRoute } from "@tanstack/react-router";

import { COMPANY_INFO } from "~/entities/company";
import type { LanguageCode } from "~/shared/i18n";
import { TranslationParams, createTc, getLanguage, i18nInstance } from "~/shared/i18n";
import { definePageTitle } from "~/shared/no-topic";
import { COLON } from "~/shared/str";

type Config = {
  titleT: TranslationParams.Type;
};

function defineHead({ titleT }: Config) {
  return (({ params }) => {
    const i18n = getI18n(getLanguageFromParams(params));
    const tc = createTc(i18n.t.bind(i18n));

    return {
      meta: [
        {
          title: definePageTitle(COMPANY_INFO.name, tc(...TranslationParams.toTuple(titleT))),
        },
      ],
    };
  }) satisfies (params: {
    params: Record<string, unknown>;
  }) => ReturnType<
    NonNullable<NonNullable<Parameters<ReturnType<typeof createFileRoute>>[0]>["head"]>
  >;
}

function defineOpenGraphProperty({ property, content }: { property: string; content: string }) {
  return {
    property: ["og", property].join(COLON),
    content,
  };
}

function getLanguageFromParams(params: Record<string, unknown>) {
  type Params = {
    locale?: string | undefined;
  };
  return getLanguage((params as Params).locale);
}

function getI18n(locale: LanguageCode) {
  return i18nInstance.cloneInstance({
    lng: locale,
  });
}

export { defineHead, defineOpenGraphProperty, getI18n, getLanguageFromParams };
